import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ArrowDown = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M9.99 17.5a2 2 0 0 1-1.444-.62L.966 8.91a1.995 1.995 0 0 1 2.89-2.75l6.137 6.453 6.152-6.454a1.995 1.995 0 1 1 2.887 2.753l-7.597 7.97a2 2 0 0 1-1.445.618" }) }));
});
ArrowDown.displayName = 'ArrowDown';
ArrowDown.__iconComponentType = 'standard';
export default ArrowDown;
//# sourceMappingURL=ArrowDown.js.map